/* eslint-disable sonarjs/no-duplicate-string */

module.exports = {
  development: {
    API_URL: 'http://localhost:3000',
    ROOT_URL: 'http://localhost:3001/',
    STRIPE_KEY: 'pk_test_SkZaLRLKf52FDDO6qRyCaAN4',
    SEGMENT_WRITE_KEY: 'u2q60SmpwhAX9rCqhfuljX0DnZO2TrtC',
    STATIC_ASSET_HOST_URL: 'https://static.gg-dev.link',
    RECAPTCHA_SITE_KEY: '6Lf857coAAAAAGbiajgyV8-78tJOeWYIOg5QD6JT',
  },
  staging: {
    API_URL: 'https://api.glossgenius-staging.com',
    ROOT_URL: 'http://glossgenius-staging.com/',
    STRIPE_KEY: 'pk_test_FgCV2kL5DuXGbtlZ7Y6fyQ8y',
    SEGMENT_WRITE_KEY: 'H2hmjvy9CmSt7yFmO3dBwVkkBi42ytQP',
    STATIC_ASSET_HOST_URL: 'https://static.glossgenius-staging.com',
    RECAPTCHA_SITE_KEY: '6Lf857coAAAAAGbiajgyV8-78tJOeWYIOg5QD6JT',
  },
  prod: {
    API_URL: 'https://api.glossgenius.com',
    ROOT_URL: 'https://glossgenius.com/',
    STRIPE_KEY: 'pk_live_Usjn92dyX45Hqq9NQ0OjcKwg',
    FB_PIXEL_ID: '278979275949812',
    SEGMENT_WRITE_KEY: 'Gm2OJFMDSbGJFIadNVhMlw2yCUghV1lG',
    STATIC_ASSET_HOST_URL: 'https://static.glossgenius.com',
    RECAPTCHA_SITE_KEY: '6LdbDbgoAAAAAOu6uIyr20aLrbvlWNzUBWqF49RO',
    DATADOG_APPLICATION_ID: '4a4abc07-5674-4bb6-a824-7c4b6c348c76',
    DATADOG_CLIENT_TOKEN: 'pubf62350c670fce989df93e074b275f162',
  },
  qa: {
    STRIPE_KEY: 'pk_test_ow0bVaIXnDJw4H5qm2USxJM300z5NgLlHQ',
    API_URL: 'https://api.glossgenius-qa.com',
    ROOT_URL: 'https://glossgenius-qa.com/',
    SEGMENT_WRITE_KEY: 'u2q60SmpwhAX9rCqhfuljX0DnZO2TrtC',
    STATIC_ASSET_HOST_URL: 'https://static.glossgenius-qa.com',
    RECAPTCHA_SITE_KEY: '6Lf857coAAAAAGbiajgyV8-78tJOeWYIOg5QD6JT',
  },
  integrationTest: {
    API_URL: 'http://localhost:8888',
    ROOT_URL: 'http://mocksalon.lvh.me:3001',
    STRIPE_KEY: 'pk_test_FgCV2kL5DuXGbtlZ7Y6fyQ8y',
    SEGMENT_WRITE_KEY: 'H2hmjvy9CmSt7yFmO3dBwVkkBi42ytQP',
    STATIC_ASSET_HOST_URL: 'https://static.gg-dev.link',
    RECAPTCHA_SITE_KEY: '6Lf857coAAAAAGbiajgyV8-78tJOeWYIOg5QD6JT',
  },
};
